import { createContext } from "react";

const CatTipoCorteCajaContext = createContext();

export default CatTipoCorteCajaContext;
